<template>
  <base-modal size="550" :is-open="isOpen" @close="closeModal">
    <div v-if="listAll().length" class="add-people-team">
      <h2 class="add-people-team__header">Добавить услугу</h2>
      <div class="subtitle">
        <span>Прикрепите до 3 услуг из вашего профиля</span>
      </div>
      <div class="body">
        <perfect-scrollbar>
          <div class="list">
            <service-task
              v-for="(option, idx) in listAll()"
              class="item"
              :rating="option.rating"
              :industry="option.name"
              :like="getLikeString(option.rating_count)"
              :model-value="option.value"
              @update:model-value="(v) => select([option])"
              checkbox-action
              small
            />
          </div>
        </perfect-scrollbar>
      </div>
      <base-button @click="submit">{{
        nameButton !== "" ? nameButton : "Добавить"
      }}</base-button>
    </div>

    <div v-else class="add-people-team">
      <h2 class="add-people-team__header">Добавьте услугу</h2>
      <div class="subtitle">
        <span
          >Для отклика на проект вам потребуется прикрепить релевантный опыт. Пожалуйста,
          заполните его заранее, чтобы не прерывать заполнение услуги.
        </span>
      </div>
      <div class="body"></div>
      <base-button @click="addService">Заполнить опыт</base-button>
    </div>
  </base-modal>
</template>

<script>
import { declOfNum } from "@/utils/helper";
import BaseModal from "@/components/base/BaseModal";
import BaseButton from "@/components/base/BaseButton";
import ServiceTask from "@/components/ui/ServiceTask";
import useSelectController from "@/hooks/useSelectController";
/**
 * @property {string} text - Текст с поля для ввода
 */
class EventVerificationModalData {
  text = "";
}

export default {
  name: "AddServicesModal",
  components: {
    ServiceTask,
    BaseButton,
    BaseModal,
  },
  setup(props) {
    const {
      submitSelect,
      addListSelect,
      listAll,
      searchSelect,
      selectValue,
      isNewValue,
      isSelectValue,
      removeSelect,
    } = useSelectController({ selectOne: false, newValue: false });
    return {
      submitSelect,
      addListSelect,
      listAll,
      searchSelect,
      selectValue,
      isNewValue,
      isSelectValue,
      removeSelect,
    };
  },
  props: {
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    modelValue: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      inputValidPhone: false,
      nameButton: "",
      verificationCode: "",
      dataOptions: [],
      isOpenModalDesiredClients: false,
    };
  },
  methods: {
    getLikeString(count) {
      if (count && count > 0) {
        let str = declOfNum(count, ["оценка", "оценки", "оценок"]);
        return `${count} ${str}`;
      } else {
        return "";
      }
    },
    select(v) {
      console.log(v);
      this.selectValue(v);
    },
    closeModal() {
      this.$emit("close");
    },
    submit() {
      let submitSelect = this.submitSelect();
      console.log(submitSelect);
      if (submitSelect != -1) {
        this.$emit("update:modelValue", submitSelect);
        this.closeModal();
      }
    },
    addService() {
      this.$router.replace({ name: "ServiceAddPage" });
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue != null)
          if (newValue.length > 0) {
            this.selectValue(newValue, true);
          }
      },
    },
    items: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue != null) {
          this.addListSelect(JSON.parse(JSON.stringify(newValue)));
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/scss/vuetify_variables";
.add-people-team {
  &__header {
    @include desktop_h2;
    text-align: left;
    margin-bottom: 16px;
  }
  .body {
    margin-bottom: 30px;
    max-height: 52vh;
    margin: 24px -18px 16px -18px;
    padding-left: 18px;
    .ps {
      max-height: 50vh;
    }
    .list {
      padding-right: 18px;
    }
    .item {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.subtitle {
  @include desktop_additional;
  text-align: left;
  margin-bottom: 16px;
}

.service-task.small {
  @include sm {
    padding: 20px;
  }
}
</style>
